// Full-screen Volugraph logo + spinner (auth transitions, protected routes).

import React from 'react';
import volugraphLogo from '../assets/icons/Volugraph Logo.png';

export default function VolugraphLoadingScreen({ className = '', overlay = false }) {
  return (
    <div
      className={`protected-route-loading${overlay ? ' protected-route-loading--overlay' : ''}${className ? ` ${className}` : ''}`.trim()}
      aria-label="Loading"
    >
      <div className="protected-route-loading-content">
        <span className="protected-route-spinner" aria-hidden="true" />
        <img src={volugraphLogo} alt="Volugraph" className="protected-route-logo" />
      </div>
    </div>
  );
}
